/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Edit_Calibration_SyncInputs */



/**
* | output |
* | --- |
* | "The head th. is synchronizing" |
*
* @param {Valve_Edit_Calibration_SyncInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_edit_calibration_sync = /** @type {((inputs?: Valve_Edit_Calibration_SyncInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Edit_Calibration_SyncInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The head th. is synchronizing")
	return /** @type {LocalizedString} */ ("La tête th. est en train de se synchroniser")
});